import { useContext, useState, useEffect, useMemo } from 'react';
import AuthContext from '../../context/autenticacion/authContext';
import { useT } from 'i18n';

const ESTADOS = {
  APROBADO: { clase: 'ok', texto: 'dep.estAprobado' },
  RECHAZADO: { clase: 'bad', texto: 'dep.estRechazado' },
  'EN PROCESO': { clase: 'wait', texto: 'dep.estRevision' },
  'EN REVISION': { clase: 'wait', texto: 'dep.estRevision' },
};

const TIPOS = {
  'DEPOSITO CRIPTO': 'USDT',
  'TRANSFERENCIA BANCARIA INTERNACIONAL': 'dep.tipoInternacional',
  'ACH USA': 'ACH USA',
  PAYPAL: 'PayPal',
  REMESA: 'dep.tipoRemesa',
  'ACH PANAMA': 'dep.tipoAchPanama',
};

const formatoMonto = (v) => {
  const n = parseFloat(String(v ?? 0).replace(/,/g, ''));
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const TodosMisDepositos = () => {
  const { t } = useT();
  const { depositos } = useContext(AuthContext);
  const [term, setTerm] = useState('');
  const [pagina, setPagina] = useState(1);
  const porPagina = 10;
  const lista = useMemo(() => depositos || [], [depositos]);

  const filtrados = useMemo(() => {
    const q = term.trim().toLowerCase();
    if (!q) return lista;
    return lista.filter((d) => [d.fecha, d.tipo, d.estado, d.monto, d.network, d.note]
      .some((v) => v && String(v).toLowerCase().includes(q)));
  }, [lista, term]);

  const maximo = Math.max(1, Math.ceil(filtrados.length / porPagina));
  const visibles = filtrados.slice((pagina - 1) * porPagina, pagina * porPagina);
  useEffect(() => { setPagina(1); }, [term]);

  if (lista.length === 0) {
    return (
      <div className="p7-empty">
        <p>{t('dep.vacioTitulo')}</p>
        <p className="p7-empty-sub">{t('dep.vacioAyuda')}</p>
      </div>
    );
  }

  return (
    <>
      <div className="p7-table-tools">
        <input type="search" placeholder={t('dep.buscar')} value={term} maxLength={30}
          onChange={(e) => setTerm(e.target.value)} aria-label={t('dep.buscarAria')} />
        {maximo > 1 && (
          <div className="p7-pager" role="navigation" aria-label={t('dep.paginas')}>
            <button type="button" onClick={() => setPagina((p) => Math.max(1, p - 1))} disabled={pagina === 1} aria-label={t('dep.pagAnterior')}>‹</button>
            <span>{t('dep.pagina', { pagina, maximo })}</span>
            <button type="button" onClick={() => setPagina((p) => Math.min(maximo, p + 1))} disabled={pagina === maximo} aria-label={t('dep.pagSiguiente')}>›</button>
          </div>
        )}
      </div>

      <div className="p7-table-wrap">
        <table className="p7-table">
          <thead>
            <tr><th>{t('dep.colFecha')}</th><th>{t('dep.colDetalle')}</th><th className="p7-num">{t('dep.colMonto')}</th><th>{t('dep.colEstado')}</th></tr>
          </thead>
          <tbody>
            {visibles.map((d, i) => {
              const est = ESTADOS[(d.estado || '').toUpperCase()] || { clase: 'wait', texto: d.estado, crudo: true };
              return (
                <tr key={d.id || i}>
                  <td>{d.fecha}</td>
                  <td>
                    {TIPOS[d.tipo] ? t(TIPOS[d.tipo]) : d.tipo}
                    {d.network && <span className="p7-sub"> · {d.network}</span>}
                    {est.clase === 'bad' && d.rechazo && <span className="p7-sub p7-sub-bad">{t('dep.motivo', { motivo: d.rechazo })}</span>}
                  </td>
                  <td className="p7-num">{formatoMonto(d.monto)}</td>
                  <td><span className={`p7-chip p7-chip-${est.clase}`}>{est.crudo ? est.texto : t(est.texto)}</span></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="p7-table-foot">{t(filtrados.length === 1 ? 'dep.depositoUno' : 'dep.depositoVarios', { n: filtrados.length })}</p>
    </>
  );
};

export default TodosMisDepositos;
